<template>
  <div class="analysis_wrap" id="mainBox">
    <div class="mainHead" style="margin-bottom: 10px">
      <div class="route"><span class="crumbs"></span><span>报警统计</span></div>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="告警统计" name="first"></el-tab-pane>
      <el-tab-pane label="预警统计" name="second"></el-tab-pane>
    </el-tabs>
    <div class="main clearfix" :style="{ height: heightCard + 'px' }">
      <div class="mains clearfix">
        <div style="display: flex">
          <div
            class="mold_module"
            :style="{ width: modularW + 'px', height: modularH + 'px' }"
          >
            <div class="tops clearfix">
              <h3 v-if="activeName == 'first'"><em></em>告警类型统计图</h3>
              <h3 v-else><em></em>预警类型统计图</h3>
              <div class="tops_right">
                <ul class="time_select">
                  <li
                    :class="{ li_select1: index == radio1 }"
                    v-for="(item, index) in scopeStatus"
                    :key="index"
                    @click="scopeClick1(index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
                <el-dialog
                  title="自定义时间区间"
                  :visible.sync="select1"
                  width="510px"
                >
                  <el-date-picker
                    style="margin-top: 7px; margin-bottom: 7px"
                    v-model="customData1"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                  <span slot="footer" class="dialog-footer">
                    <el-button style="min-width: 80px" @click="select1 = false"
                      >取 消</el-button
                    >
                    <el-button
                      style="min-width: 80px; margin-left: 8px"
                      type="primary"
                      @click="sureBtn1()"
                      >确 定</el-button
                    >
                  </span>
                </el-dialog>
              </div>
            </div>
            <div
              style="position: relative"
              :style="{
                height: modularH - 41 + 'px',
                'padding-top': marH + 'px',
              }"
            >
              <h4 :style="{ top: topH + 'px' }">{{ names }}</h4>
              <div
                class="tops_right"
                style="position: absolute; right: 0; top: 8px; z-index: 1"
              >
                <ul class="chart_select">
                  <li
                    :class="{ chart_select1: chartS1 }"
                    @click="planClick(true)"
                  >
                    环
                  </li>
                  <li
                    :class="{ chart_select1: !chartS1 }"
                    @click="planClick(false)"
                  >
                    柱
                  </li>
                </ul>
              </div>
              <div v-show="select5">
                <div
                  id="mold"
                  :style="{ width: chartW + 'px', height: chartH + 'px' }"
                  style="margin: 0 auto; top: -25px"
                  v-show="chartS1"
                ></div>
                <div
                  id="mold1"
                  :style="{ width: chartW + 'px', height: chartH + 'px' }"
                  style="margin: 0 auto; top: -25px"
                  v-show="!chartS1"
                ></div>
              </div>
              <div class="No" v-show="!select5">
                <img src="../../../static/img/Nodata.png" />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
          <div
            class="cost_module"
            :style="{ width: modularW + 'px', height: modularH + 'px' }"
            v-if="isAuth('common:interface')"
          >
            <div class="tops clearfix">
              <h3 v-if="activeName == 'first'"><em></em>告警处理耗时统计图</h3>
              <h3 v-else><em></em>预警处理耗时统计图</h3>
              <div class="tops_right">
                <ul class="time_select">
                  <li
                    :class="{ li_select1: index == radio2 }"
                    v-for="(item, index) in scopeStatus"
                    :key="index"
                    @click="scopeClick2(index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
                <el-dialog
                  title="自定义时间区间"
                  :visible.sync="select2"
                  width="510px"
                >
                  <el-date-picker
                    style="margin-top: 7px; margin-bottom: 7px"
                    v-model="customData2"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                  <span slot="footer" class="dialog-footer">
                    <el-button style="min-width: 80px" @click="select2 = false"
                      >取 消</el-button
                    >
                    <el-button
                      style="min-width: 80px; margin-left: 8px"
                      type="primary"
                      @click="sureBtn2()"
                      >确 定</el-button
                    >
                  </span>
                </el-dialog>
              </div>
            </div>
            <div
              style="position: relative"
              :style="{
                height: modularH - 41 + 'px',
                'padding-top': marH + 'px',
              }"
            >
              <h4 :style="{ top: topH - 10 + 'px' }">{{ names }}</h4>
              <div
                id="cost"
                :style="{ width: chartW + 'px', height: chartH + 'px' }"
                style="margin: 0 auto; top: -25px"
                v-show="select6"
              ></div>
              <div class="No" v-show="!select6">
                <img src="../../../static/img/Nodata.png" />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div
            class="chain_module"
            :style="{ width: modularW + 'px', height: modularH + 'px' }"
          >
            <div class="tops clearfix">
              <h3 v-if="activeName == 'first'">
                <em></em>告警{{ title }}统计图
              </h3>
              <h3 v-else><em></em>预警{{ title }}统计图</h3>
              <div class="tops_right">
                <el-select
                  class="chain_select"
                  v-model="year"
                  placeholder="请选择"
                  v-show="chartS3"
                >
                  <el-option
                    v-for="item in yearData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    @click.native.prevent="yearChange(item.value)"
                  >
                  </el-option>
                </el-select>
                <el-select
                  class="chain_select"
                  v-model="month"
                  placeholder="请选择"
                  v-show="!chartS3"
                >
                  <el-option
                    v-for="item in monthData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    @click.native.prevent="monthChange(item.value)"
                  >
                  </el-option>
                </el-select>
                <ul class="chart_select">
                  <li
                    :class="{ chart_select1: chartS3 }"
                    @click="chainClick(true)"
                  >
                    环比
                  </li>
                  <li
                    :class="{ chart_select1: !chartS3 }"
                    @click="chainClick(false)"
                  >
                    同比
                  </li>
                </ul>
              </div>
            </div>
            <div
              style="position: relative"
              :style="{
                height: modularH - 41 + 'px',
                'padding-top': marH + 'px',
              }"
            >
              <h4 :style="{ top: topH + 'px' }">{{ names }}</h4>
              <div
                id="chain"
                :style="{ width: chartW + 'px', height: chartH + 'px' }"
                style="margin: 0 auto; top: -25px"
                v-show="select7"
              ></div>
              <div class="No" v-show="!select7">
                <img src="../../../static/img/Nodata.png" />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
          <div
            class="ranking_module"
            :style="{ width: modularW + 'px', height: modularH + 'px' }"
          >
            <div class="tops clearfix">
              <h3 v-if="activeName == 'first'"><em></em>告警次数排名表</h3>
              <h3 v-else><em></em>预警次数排名表</h3>
              <div class="tops_right">
                <ul class="time_select">
                  <li
                    :class="{ li_select1: index == radio4 }"
                    v-for="(item, index) in scopeStatus"
                    :key="index"
                    @click="scopeClick4(index)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
                <el-dialog
                  title="自定义时间区间"
                  :visible.sync="select4"
                  width="510px"
                >
                  <el-date-picker
                    style="margin-top: 7px; margin-bottom: 7px"
                    v-model="customData4"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                  <span slot="footer" class="dialog-footer">
                    <el-button style="min-width: 80px" @click="select4 = false"
                      >取 消</el-button
                    >
                    <el-button
                      style="min-width: 80px; margin-left: 8px"
                      type="primary"
                      @click="sureBtn4()"
                      >确 定</el-button
                    >
                  </span>
                </el-dialog>
              </div>
            </div>
            <div
              style="position: relative"
              :style="{
                height: modularH - 41 + 'px',
                'padding-top': marginH + 'px',
              }"
            >
              <div
                class="tops_right"
                style="position: absolute; right: 0; top: 3px; z-index: 1"
              >
                <ul class="chart_select">
                  <li
                    :class="{ chart_select1: chartS4 }"
                    @click="rankClick(true, true)"
                  >
                    表
                  </li>
                  <li
                    :class="{ chart_select1: !chartS4 }"
                    @click="rankClick(false, false)"
                  >
                    图
                  </li>
                </ul>
              </div>
              <div v-show="select8" style="margin-top: 30px">
                <ul
                  class="rank_tabs"
                  v-show="chartS4"
                  :style="{ height: modularH - (marginH + 148) + 'px' }"
                >
                  <li
                    v-for="(item, index) in rankArr"
                    :key="index"
                    :style="{ height: (modularH - (marginH + 176)) / 5 + 'px' }"
                  >
                    <span>{{ item.name }}</span>
                    <span :style="{ left: warnLeft + 'px' }">{{
                      item.alarmCount
                    }}</span>
                    <span
                      :class="{
                        oneNum: index + 1 == 1,
                        twoNum: index + 1 == 2,
                        threeNum: index + 1 == 3,
                      }"
                      v-if="index + 1 <= 3"
                    ></span>
                    <span v-if="index + 1 > 3">{{ index + 1 }}</span>
                  </li>
                </ul>
                <div
                  id="ranking"
                  :style="{ width: chartW + 'px', height: chartH + 'px' }"
                  style="margin: 0 auto; top: -40px"
                  v-show="!chartS4"
                ></div>
              </div>
              <div class="No" v-show="!select8">
                <img src="../../../static/img/Nodata.png" />
                <span>暂无数据</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { ajaxFuncJson } from "@/api/ajax";
import Vue from "vue";
require("echarts/theme/macarons"); // echarts theme
export default {
  name: "analysis",
  components: {},
  inject: ["reload"],
  data() {
    return {
      activeName: "first",
      runStatus: 1,
      msg: "统计分析",
      title: "环比",
      names: sessionStorage.getItem("analyName"),
      heightCard: "",
      modularW: "",
      modularH: "",
      chartW: "",
      chartH: "",
      marginH: "",
      marH: "",
      topH: "",
      warnLeft: "",
      myChart1: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
      myChart5: null,
      myChart6: null,
      myChart7: null,
      myChart8: null,
      myChart9: null,
      // .............................告警类型统计数据参数.................
      typeStatisticData: {
        dayCount: 1, //时间天数
        start: "", //查询开始时间
        end: "", //查询结束时间
      },
      scopeStatus: [
        { name: "今天", val: 1 },
        { name: "7天", val: 7 },
        { name: "30天", val: 30 },
        { name: "全部", val: 9999 },
        { name: "自定义", val: -1 },
      ],
      // 告警类型统计图，自定义时间选择组件显示控制符
      select1: false,
      select5: true,
      radio1: 0,
      chartS1: true,
      customData1: "",
      moldPieSeries: [],
      // .............................告警处理耗时统计数据参数..................
      processTimeConsumingData: {
        dayCount: 1,
        start: "",
        end: "",
      },

      radio2: 0,
      select2: false,
      select6: true,
      customData2: "",
      // ............................告警环比统计数据参数...................
      alarmRatioData: {
        remark: 0, //0表示环比查询；1表示同比查询
        year: "", //当remark为0时传该参数，查询条件年份
        month: "", //当remark为1时传该参数，查询条件月份
      },
      frequencyArr: [], //告警次数数据
      rateArr: [], //增长率数据
      radio3: 0,
      chartS3: true,
      select3: true,
      select7: true,
      month: "0",
      year: "0",
      monthData: [],
      yearData: [],
      // .............................告警次数排名表数据参数......................
      alarmLevelData: {
        dayCount: 1,
        flag: true, //用于标记是表还是图，true为表，false为图
        start: "",
        end: "",
      },
      radio4: 0,
      chartS4: true,
      select4: false,
      select8: true,
      customData4: "",
      rankArr: [],
      monthArr: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      yearArr: [], //告警环比统计图年份
      windowResize: null,
      monitorTypeArr: [
        "电气",
        "水压",
        "液位",
        "可燃气",
        "烟感",
        "灭火器",
        "水浸",
        "用传",
      ],
      userType: 0,
    };
  },
  created() {
    this.userType = sessionStorage.getItem("userType");
  },
  computed: {
    getMap() {
       this.typeStatisticData= {
          dayCount: 1, //时间天数
          start: "", //查询开始时间
          end: "", //查询结束时间
        }
      this.processTimeConsumingData= {
        dayCount: 1,
        start: "",
        end: "",
      }
      this.alarmRatioData= {
        remark: 0, //0表示环比查询；1表示同比查询
        year: "", //当remark为0时传该参数，查询条件年份
        month: "", //当remark为1时传该参数，查询条件月份
      }
      this.alarmLevelData={
        dayCount: 1,
        flag: true, //用于标记是表还是图，true为表，false为图
        start: "",
        end: "",
      }
      this.radio1 =0;
      this.radio2 =0;
      this.radio4 =0;
      this.chartS1 = true;
      this.chartS3= true;
      this.chartS4= true;
      this.customData1 = "";
      this.customData2 = "";
      this.month= new Date().getMonth() + 1;
      // this.year="";
      this.customData4 = "";
      return this.$store.state.analyBuildingId;
    },
    handleOpen() {
      if (sessionStorage.getItem("userType") != 0) {
        return this.$store.state.analyCustomerId;
      } else {
        return this.$store.state.analyCustomerId;
      }
    },
    leftoggle() {
      return this.$store.state.leftoggle;
    },
  },
  watch: {
    getMap(newV, oldV) {
      // status的变化，然后执行操作
      this.typeStatisticData.dayCount = 1;
      this.names = sessionStorage.getItem("analyName");
      this.getAlarmRatioYearAndMonth();
      this.getProcessTimeConsumingData();
      this.getAlarmRatioData();
      this.getAlarmLevelData();
      this.getTypeStatisticData();
      // this.reload();
    },
    handleOpen(newV, oldV) {
      this.getAlarmRatioYearAndMonth();
      this.getProcessTimeConsumingData();
      this.getAlarmRatioData();
      this.getAlarmLevelData();
      this.getTypeStatisticData();
      // this.reload();
    },
    leftoggle(newV, oldV) {
      // status的变化，然后执行操作
      this.initFont();
    },
  },
  mounted() {
    let that = this;
    that.windowResize = function () {
      that.initFont();
    };
    that.windowResize();
    window.addEventListener("resize", that.windowResize);
    this.getTypeStatisticData();
    this.getProcessTimeConsumingData();
    if (this.isAuth("common:interface")) {
      this.getAlarmRatioYearAndMonth();
    }
    this.getAlarmLevelData();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.runStatus = 1;
      } else {
        this.runStatus = 2;
      }
      this.typeStatisticData= {
          dayCount: 1, //时间天数
          start: "", //查询开始时间
          end: "", //查询结束时间
        }
      this.processTimeConsumingData= {
        dayCount: 1,
        start: "",
        end: "",
      }
      this.alarmRatioData= {
        remark: 0, //0表示环比查询；1表示同比查询
        year: "", //当remark为0时传该参数，查询条件年份
        month: "", //当remark为1时传该参数，查询条件月份
      }
      this.alarmLevelData={
        dayCount: 1,
        flag: true, //用于标记是表还是图，true为表，false为图
        start: "",
        end: "",
      }
      this.radio1 =0;
      this.radio2 =0;
      this.radio4 =0;
      this.chartS1 = true;
      this.chartS3= true;
      this.chartS4= true;
      this.customData1 = "";
      this.customData2 = "";
      this.month= new Date().getMonth() + 1;
      // this.year="";
      this.customData4 = "";
      this.getAlarmRatioYearAndMonth();
      this.getProcessTimeConsumingData();
      this.getAlarmRatioData();
      this.getAlarmLevelData();
      this.getTypeStatisticData();
    },
    // 公用柱状图
    analysis(charts, id, s, ldata, xdata, ydata, serie) {
      charts = this.$echarts.init(document.getElementById(id));
      charts.clear(); //ceshi

      let _this = this;
      let option = {
        color: ["#198cff", "#4caf50"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "none", // 默认为直线，可选为：'line' | 'shadow' 'none' 'cross'
          },
          padding: 10,
        },
        legend: {
          show: s,
          top: 20,
          data: ldata,
          itemWidth: 10,
          itemHeight: 10,
          icon: "stack",
          itemGap: 45,
          textStyle: {
            padding: [3, -5, 0, 0],
          },
        },
        grid: {
          left: 0,
          right: 0,
          bottom: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisTick: {
            alignWithLabel: true, //刻度与文字中间对齐
          },
          axisLabel: {
            interval: 0,
          },
          data: xdata,
        },
        yAxis: {
          type: "value",
          name: ydata,
          splitLine: {
            lineStyle: {
              color: "#efefef",
            },
          },
          axisLabel: {
            //刻度标签
          },
          axisTick: {
            //刻度相关设置
            show: true,
          },
        },
        series: serie,
      };
      charts.setOption(option, true);
    },
    // ......................................告警类型统计模块.,,,,,,,..................

    // 饼图
    moldAnalysis(color) {
      this.myChart1 = this.$echarts.init(document.getElementById("mold"));
      this.myChart1.clear(); //ceshi
      let option = {
        // color: ['#04cdad','#00c7fe','#198cff','#feb000','#fe7c16','#ff4c59'],
        color: color,
        legend: {
          orient: "vertical",
          x: "left",
          y: "center",
          left: 80,
          itemWidth: 15,
          itemHeight: 15,
          icon: "rect",
          textStyle: {
            fontSize: 13,
            color: "#282828",
            lineHeight: 20,
          },
        },
        series: [
          {
            type: "pie",
            radius: ["47.5%", "62.4%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: "#282828",
                  fontSize: "16",
                  fontWeight: "normal",
                },
                formatter: ["{name|{b}}", "{value|{c}次}({percent|{d}%})"].join(
                  "\n"
                ),
                rich: {
                  name: {
                    color: "#282828",
                    fontSize: 16,
                    fontWeight: "bold",
                  },
                  value: {
                    color: "#282828",
                    fontSize: 13,
                    fontWeight: "normal",
                    padding: [10, 5, 10, 0],
                  },
                  percent: {
                    color: "#282828",
                    fontSize: 13,
                    fontWeight: "normal",
                    padding: 0,
                  },
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: this.moldPieSeries,
          },
        ],
      };
      this.myChart1.setOption(option, true);
    },
    // 告警类型统计图
    getTypeStatisticData() {
      if (this.isAuth("common:interface")) {
        this.moldPieSeries = [];
        let parms = {
          dayCount: this.typeStatisticData.dayCount,
          start: this.typeStatisticData.start,
          end: this.typeStatisticData.end,
          runStatus: this.runStatus,
        };
        parms = this.setParamByUserType(parms);
        var colorArr = [
          "#04cdad",
          "#00c7fe",
          "#198cff",
          "#fe7c16",
          "#feb000",
          "#ff4c59",
          "#0066ff",
          "#FF0000"
        ];
        ajaxFuncJson("/statisticAnalysis/getTypeStatistic", parms).then(
          (res) => {
            if (res.data.status == 200) {
              let datas = res.data.data.typeList;
              if (datas.length > 0) {
                this.select5 = true;
                let moldX = [];
                let moldY = [];
                let moldBarSeries = [];
                let color = [];
                for (var i in datas) {
                  var obj = {};
                  obj.value = datas[i].typeCount;
                  var monitorTypeName = this.monitorTypeArr[datas[i].type - 1];
                  color.push(colorArr[datas[i].type - 1]);
                  moldX.push(monitorTypeName);
                  obj.name = monitorTypeName;
                  moldY.push(datas[i].typeCount);
                  this.moldPieSeries.push(obj);
                }
                // 柱图series
                moldBarSeries.push({
                  type: "bar",
                  barWidth: 15, //柱图宽度
                  data: moldY,
                });
                this.moldAnalysis(color);
                this.analysis(
                  this.myChart2,
                  "mold1",
                  false,
                  "",
                  moldX,
                  "次",
                  moldBarSeries
                );
              } else {
                this.select5 = false;
              }
            }
          }
        );
      }
    },
    // 环、柱点击
    planClick(boolen) {
      this.chartS1 = boolen;
      this.getTypeStatisticData();
    },
    //时间筛选按钮
    scopeClick1(index) {
      this.radio1 = index;
      this.typeStatisticData.dayCount = this.scopeStatus[index].val;
      var dayCount = this.scopeStatus[index].val;
      if (dayCount == -1) {
        // 若选择了自定义时间,打开时间选择器
        this.select1 = true;
      } else {
        this.moldPieSeries = [];
        this.typeStatisticData.start = "";
        this.typeStatisticData.end = "";
        this.getTypeStatisticData();
      }
    },
    // 自定义时间点击确定按钮
    sureBtn1() {
      this.moldPieSeries = [];
      this.select1 = false;
      if (this.customData1) {
        this.typeStatisticData.start = this.customData1[0];
        this.typeStatisticData.end = this.customData1[1];
        this.typeStatisticData.dayCount = -1;
        this.getTypeStatisticData();
      } else {
        this.typeStatisticData.start = "";
        this.typeStatisticData.end = "";
      }
    },

    // ....................................告警处理耗时统计模块........,,,,,,,,,,,,,,

    // 接口
    getProcessTimeConsumingData() {
      let parms = {
        dayCount: this.processTimeConsumingData.dayCount,
        start: this.processTimeConsumingData.start,
        end: this.processTimeConsumingData.end,
        runStatus: this.runStatus,
      };
      parms = this.setParamByUserType(parms);
      ajaxFuncJson("/statisticAnalysis/getProcessTimeConsuming", parms).then(
        (res) => {
          if (res.data.status == 200) {
            let datas = res.data.data;
            if (datas.length > 0) {
              this.select6 = true;
              let costX = [];
              let costSeries1 = [];
              let costSeries2 = [];
              let costBarSeries = [];
              for (var i in datas) {
                if (datas[i].type == 1) {
                  costX.push("电气");
                } else if (datas[i].type == 2) {
                  costX.push("水压");
                } else if (datas[i].type == 3) {
                  costX.push("液位");
                } else if (datas[i].type == 4) {
                  costX.push("可燃气");
                } else if (datas[i].type == 5) {
                  costX.push("烟感");
                } else if (datas[i].type == 6) {
                  costX.push("灭火器");
                } else if (datas[i].type == 7) {
                  costX.push("水浸");
                }else if (datas[i].type == 8) {
                  costX.push("用传");
                }
                costSeries1.push(datas[i].solveTime);
                costSeries2.push(datas[i].verifyTime);
              }
              costBarSeries.push(
                {
                  name: "审核时长",
                  type: "bar",
                  stack: "总量",
                  barWidth: 15, //柱图宽度
                  data: costSeries2,
                },
                {
                  name: "处理时长",
                  type: "bar",
                  stack: "总量",
                  barWidth: 15, //柱图宽度
                  data: costSeries1,
                }
              );
              this.analysis(
                this.myChart3,
                "cost",
                true,
                ["处理时长", "审核时长"],
                costX,
                "分钟",
                costBarSeries
              );
            } else {
              this.select6 = false;
            }
          }
        }
      );
    },
    //时间筛选按钮
    scopeClick2(index) {
      this.radio2 = index;
      this.processTimeConsumingData.dayCount = this.scopeStatus[index].val;
      var dayCount = this.scopeStatus[index].val;
      if (dayCount == -1) {
        this.select2 = true;
      } else {
        this.processTimeConsumingData.start = "";
        this.processTimeConsumingData.end = "";
        this.getProcessTimeConsumingData();
      }
    },
    // 自定义时间点击确定按钮
    sureBtn2() {
      this.select2 = false;
      if (this.customData2) {
        this.processTimeConsumingData.start = this.customData2[0];
        this.processTimeConsumingData.end = this.customData2[1];
        this.getProcessTimeConsumingData();
      } else {
        this.processTimeConsumingData.start = "";
        this.processTimeConsumingData.end = "";
      }
    },

    // ....................................告警环比统计模块,,,,,,,,..................

    //图表
    chainAnalysis(series) {
      this.myChart4 = this.$echarts.init(document.getElementById("chain"));
      this.myChart4.clear(); //ceshi
      let _this = this;
      let currentMonth = new Date().getMonth() + 1;
      let currentYear = new Date().getFullYear(); //当前年份
      let option = {
        color: ["#198cff", "#f55353"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow' 'none' 'cross'
            shadowStyle: {
              opacity: 0,
            },
          },
          padding: 10,
          formatter: function (value, index) {
            if (
              _this.year == currentYear &&
              currentMonth < value[0].name &&
              _this.year != value[0].name &&
              _this.year != parseInt(value[0].name) + 1
            ) {
            } else {
              if (_this.chartS3) {
                var htmlStr = "";
                var valMap = {};
                for (var i = 0; i < value.length; i++) {
                  var param = value[i];
                  var seriesName = param.seriesName;
                  var valueY = param.value;
                  //过虑无效值
                  if (value[i].value == "-") {
                    continue;
                  }
                  //过滤重叠值
                  if (valMap[seriesName] == valueY) {
                    continue;
                  }
                  valMap[seriesName] = valueY;
                  if (i === 0) {
                    htmlStr += _this.year + "-" + param.name + "<br/>";
                    htmlStr += seriesName + "：" + valueY + "<br/>";
                  } else {
                    htmlStr +=
                      seriesName + "：" + Math.round(valueY) + "%" + "<br/>";
                  }
                }
                return htmlStr;
              } else {
                var htmlStrMonth = "";
                var valMapMonth = {};
                for (var j = 0; j < value.length; j++) {
                  var paramMonth = value[j];
                  var seriseNameMonth = paramMonth.seriesName;
                  var valueMonth = paramMonth.value;
                  //过滤无效值
                  if (value[j].value == "-") {
                    continue;
                  }
                  //过滤重叠值
                  if (valMapMonth[seriseNameMonth] == valueMonth) {
                    continue;
                  }
                  valMapMonth[seriseNameMonth] = valueMonth;
                  if (j === 0) {
                    htmlStrMonth +=
                      paramMonth.name + "-" + _this.month + "</br>";
                    htmlStrMonth +=
                      seriseNameMonth + "：" + valueMonth + "</br>";
                  } else {
                    htmlStrMonth +=
                      seriseNameMonth +
                      "：" +
                      Math.round(valueMonth) +
                      "%" +
                      "</br>";
                  }
                }
                return htmlStrMonth;
              }
            }
          },
        },
        grid: {
          left: 0,
          right: 0,
          bottom: "4%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.yearArr,
            axisPointer: {
              type: "shadow",
            },
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "次",
            splitLine: {
              lineStyle: {
                color: "#efefef",
              },
            },
          },
          {
            type: "value",
            axisLabel: {
              formatter: "{value} %",
            },
            splitLine: {
              lineStyle: {
                color: "#efefef",
                opacity: 0,
              },
            },
          },
        ],
        series: series,
      };
      this.myChart4.setOption(option, true);
    },
    // 获取条件查询数据
    getAlarmRatioYearAndMonth() {
      var that = this;
      this.frequencyArr = [];
      this.rateArr = [];
      let parms = {};
      parms = this.setParamByUserType(parms);
      ajaxFuncJson("/statisticAnalysis/getAlarmRatioYearAndMonth", parms).then(
        (res) => {
          if (res.data.status == 200) {
            let datasMonth = res.data.data.month;
            let dataYear = res.data.data.year;
            if (
              (!datasMonth || datasMonth.length == 0) &&
              (!dataYear || dataYear.length == 0)
            ) {
              that.select7 = false;
            }
            var currentDate = new Date();
            var currentYear = currentDate.getFullYear();
            var currentMonth = currentDate.getMonth() + 1;
            // 年列表中或月列表中是否包含当前年或月。
            var flag = false;
            for (var y in dataYear) {
              if (dataYear[y] == currentYear) {
                flag = true;
              }
            }
            if (!flag) {
              // 若无当前年份，则添加当前年份
              dataYear.push(currentYear);
            }
            flag = false;
            for (var m in datasMonth) {
              if (datasMonth[m] == currentMonth) {
                flag = true;
              }
            }
            if (!flag) {
              // 若无当前月份，则添加当前月份
              datasMonth.push(currentMonth);
            }
            // 对数组进行排序，逆序
            this.sort(dataYear);
            this.sort(datasMonth);
            this.year = dataYear[0];
            this.alarmRatioData.year = dataYear[0];
            // this.month = datasMonth[0];
            // this.alarmRatioData.month = datasMonth[0];
            this.month = new Date().getMonth() + 1;
            this.alarmRatioData.month = new Date().getMonth() + 1;
this.monthData = []
            for (var i in datasMonth) {
              var obj = {};
              obj.value = datasMonth[i];
              obj.label = datasMonth[i] + "月";
              this.monthData.push(obj);
            }
this.yearData=[]
            for (var i in dataYear) {
              var obj1 = {};
              obj1.value = dataYear[i];
              obj1.label = dataYear[i] + "年";
              this.yearData.push(obj1);
            }
            this.getAlarmRatioData();
          }
        }
      );
    },
    /**
     * 排序
     */
    sort(arr) {
      if (arr && arr.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i] < arr[j]) {
              var temp = arr[i];
              arr[i] = arr[j];
              arr[j] = temp;
            }
          }
        }
      }
    },
    /**
     * 环比/同比接口
     */
    getAlarmRatioData() {
      var that = this;
      if (!this.isAuth("common:interface")) {
        return;
      }
      this.frequencyArr = [];
      this.rateArr = [];
      this.yearArr = this.monthArr;
      var flag = this.chartS3;
      var remark = 0;
      if (!flag) {
        // 同比
        this.yearArr = [];
        remark = 1;
        if (this.yearData.length == 0) {
          this.select7 = false;
          return false;
        }
      } else {
        // 环比时保证年份不为空
        if (this.monthData.length == 0) {
          this.select7 = false;
          return false;
        }
      }
      let parms = {
        remark: remark,
        year: this.alarmRatioData.year,
        month: this.alarmRatioData.month,
        runStatus: this.runStatus,
      };
      parms = this.setParamByUserType(parms);
      ajaxFuncJson("/statisticAnalysis/getAlarmRatio", parms).then((res) => {
        if (res.data.status == 200) {
          let datas = res.data.data;
          // alert(datas.length)
          var lineArr = that.setAlarmRatioLineData(datas);
          if (parms.remark == 0) {
            var nowDate = new Date();
            if (parms.year == nowDate.getFullYear()) {
              for (var i = nowDate.getMonth() + 1; i < 12; i++) {
                lineArr[0][i] = "-";
                lineArr[1][i] = "-";
                lineArr[2][i] = "-";
                lineArr[3][i] = "-";
              }
            }
          }
          var subStr = []; //将字符串转为数组
          if (datas.length == 0) {
            datas = [{ month: 0, year: 2020, warnNum: 0, increateRate: 0 }];
          }
          if (datas.length > 0 && this.select7) {
            for (var i in datas) {
              this.frequencyArr.push(datas[i].warnNum);
              if (!flag) {
                this.yearArr.push(datas[i].year);
              }
            }
            let barJson = {
              name: (this.activeName == "first" ? "告警" : "预警") + "次数",
              type: "bar",
              barWidth: 15, //柱图宽度
              data: this.frequencyArr,
              symbol: "none",
            };
            subStr.push(barJson);
            var lineStyleType = "solid";
            for (var i = 0; i < 4; i++) {
              if (i > 1) {
                lineStyleType = "dashed";
              }
              let json = {
                name: "增长率",
                type: "line",
                yAxisIndex: 1,
                data: lineArr[i],
                itemStyle: {
                  opacity: 0,
                },
                lineStyle: {
                  type: lineStyleType,
                },
              };
              subStr.push(json);
            }
            this.chainAnalysis(subStr);
          } else {
            this.select7 = false;
          }
        }
      });
    },

    setAlarmRatioLineData(data) {
      // 数组第一个下标0-3分别表示，实线，补充实线，虚线，补充虚线，第二个下标则表示图表上的数据
      let lineArr = new Array();
      for (var i = 0; i < 4; i++) {
        lineArr[i] = new Array();
        for (var j = 0; j < data.length; j++) {
          lineArr[i][j] = "-";
        }
      }
      if (data && data.length > 0) {
        // 告警增长率
        let alarmRatiolist = [data.length];
        // 上一个值
        let lastVal = 0;
        var currentVal;
        // 计算增长率
        for (var i = 0; i < data.length; i++) {
          alarmRatiolist[i] = data[i].increateRate;
        }
        for (var i = 0; i < alarmRatiolist.length; i++) {
          currentVal = alarmRatiolist[i];
          if (i == 1) {
            // 判断第二笔数据是否为0
            if (currentVal == 0) {
              lineArr[2][i - 1] = "0.0";
            } else {
              lineArr[0][i - 1] = "0.0";
            }
          }
          if (i > 0) {
            var lineStyle = "solid";
            if (currentVal == 0) {
              // 任意数与0的连线都是虚线 任意数与非0数的连线都是实线
              lineStyle = "dashed";
            }
            lineArr = this.checkLastLine(
              i,
              lineStyle,
              lineArr,
              lastVal,
              currentVal
            );
          }
          lastVal = alarmRatiolist[i];
        }
      }
      return lineArr;
    },

    /**
     * 判断上一条直线是否为虚线或实线
     */
    checkLastLine(index, curLineStyle, lineArr, lastVal, curVal) {
      // 默认从实线开始
      var lineIndexStart = 0;
      if (curLineStyle == "dashed") {
        // 当前需连接的为虚线，则查看上一线段是否为实线
        lineIndexStart = 2;
      }
      // 上一线段是否为对立线段
      var flag = false;
      for (var i = lineIndexStart; i < lineIndexStart + 2; i++) {
        if (index > 1) {
          var lastLineStartVal = lineArr[i][index - 2];
          var lastLineEndVal = lineArr[i][index - 1];
          if (lastLineStartVal != "-" && lastLineEndVal != "-") {
            flag = true;
            break;
          }
        }
      }
      var connetIndex = lineIndexStart;
      if (flag) {
        connetIndex = connetIndex + 1;
      }
      lineArr[connetIndex][index - 1] = lastVal;
      lineArr[connetIndex][index] = curVal;
      return lineArr;
    },

    // 环比/同比点击
    chainClick(boolen) {
      if (boolen) {
        this.title = "环比";
      } else {
        this.title = "同比";
      }
      this.frequencyArr = [];
      this.rateArr = [];
      this.chartS3 = boolen;
      this.getAlarmRatioData();
    },
    yearChange(ind) {
      this.alarmRatioData.year = ind;
      this.getAlarmRatioData();
    },
    monthChange(ind) {
      this.alarmRatioData.month = ind;
      this.getAlarmRatioData();
    },

    // .......................................告警次数排名表模块..........................

    // 接口
    getAlarmLevelData() {
      if (this.isAuth("common:interface")) {
        this.rankArr = [];
        let parms = {
          dayCount: this.alarmLevelData.dayCount,
          flag: this.alarmLevelData.flag,
          start: this.alarmLevelData.start,
          end: this.alarmLevelData.end,
          runStatus: this.runStatus,
        };
        parms = this.setParamByUserType(parms);
        if (parms.buildingId) {
          parms.flag = false;
        } else {
          parms.flag = true;
        }
        ajaxFuncJson("/statisticAnalysis/getAlarmLevel", parms).then((res) => {
          if (res.data.status == 200) {
            let datas = res.data.data;
            if (datas.length > 0) {
              this.select8 = true;
              let rankX = [];
              let rankY = [];
              let rankBarSeries = [];
              this.rankArr =[];
              for (var i in datas) {
                var obj = {};
                obj.name = datas[i].name;
                obj.alarmCount = datas[i].alarmCount + "次";
                this.rankArr.push(obj);
                rankX.push(datas[i].name);
                rankY.push(datas[i].alarmCount);
              }
              if (this.alarmLevelData.flag == false) {
                rankBarSeries.push({
                  name: (this.activeName == "first" ? "告警" : "预警") + "次数",
                  type: "bar",
                  barWidth: 15, //柱图宽度
                  data: rankY,
                });
                this.analysis(
                  this.myChart5,
                  "ranking",
                  false,
                  "",
                  rankX,
                  "次",
                  rankBarSeries
                );
              }
            } else {
              this.select8 = false;
            }
          }
        });
      }
    },
    // 表/图点击
    rankClick(boolen, num) {
      this.rankArr = [];
      this.chartS4 = boolen;
      this.alarmLevelData.flag = num;
      this.getAlarmLevelData();
    },
    //时间筛选按钮
    scopeClick4(index) {
      this.radio4 = index;
      this.alarmLevelData.dayCount = this.scopeStatus[index].val;
      var dayCount = this.scopeStatus[index].val;
      if (dayCount == -1) {
        this.select4 = true;
      } else {
        this.alarmLevelData.start = "";
        this.alarmLevelData.end = "";
        this.getAlarmLevelData();
      }
    },
    // 自定义时间点击确定按钮
    sureBtn4() {
      this.alarmLevelData.start = this.customData4[0];
      this.alarmLevelData.end = this.customData4[1];
      this.rankArr = [];
      this.select4 = false;
      this.getAlarmLevelData();
    },
    // 宽高自适应
    initFont() {
      let that = this;
      this.heightCard =
        $(document.body).height() -
        $(".el-header").outerHeight(true) -
        $(".mainHead").outerHeight(true) -
        20 -
        42;
      this.modularW = ($(".mains").width() - 10) / 2;
      this.modularH = (this.heightCard - 10) / 2;
      this.chartW = this.modularW * 0.89;
      this.chartH = (this.modularH - 41) * 0.94;
      this.marginH = (this.modularH - 41) * 0.05;
      this.marH = (this.modularH - 41) * 0.08;
      this.topH = (this.modularH - 41) * 0.05;
      this.warnLeft = this.chartW * 0.48;
      setTimeout(function () {
        that.$echarts
          .init(document.getElementById("mold"))
          .resize({ width: null, height: null });
        that.$echarts
          .init(document.getElementById("mold1"))
          .resize({ width: null, height: null });
        that.$echarts
          .init(document.getElementById("cost"))
          .resize({ width: null, height: null });
        that.$echarts
          .init(document.getElementById("chain"))
          .resize({ width: null, height: null });
        that.$echarts
          .init(document.getElementById("ranking"))
          .resize({ width: null, height: null });
      }, 100);
    },
    /**
     * 根据用户类型修改传参
     */
    setParamByUserType(param) {
      var customerId = sessionStorage.getItem("customerId1");
      param.buildingId = sessionStorage.getItem("analyBuildingId");
      param.customerId = customerId;
      return param;
    },
  },
  destroyed() {
    let _this = this;
    window.removeEventListener("resize", _this.windowResize);
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
#mainBox {
  .el-dialog__body input {
    width: 80px !important;
  }
  .mains {
    margin-right: 1.05%;
    > div > div {
      position: relative;
      float: left;
      background-color: #fff;
    }
    h3 {
      font-size: 14px;
      color: #282828;
      float: left;
      line-height: 40px;
      em {
        display: inline-block;
        width: 6px;
        height: 16px;
        margin: 0 8px 0 10px;
        background-color: #198cff;
        vertical-align: -3px;
      }
    }
    h4 {
      position: absolute;
      left: 50%;
      color: $TxteAllcolor;
      text-align: center;
      font-weight: bold;
      font-size: $fontSizeThree;
      @include translates(-50%, 0);
    }
    .mold_module {
      margin: 0 10px 10px 0;
    }
    .cost_module {
      margin-bottom: 10px;
    }
    .chain_module {
      margin-right: 10px;
    }
  }
  .tops {
    border-bottom: 1px solid #f0f0f0;
    background-color: #fafafa;
  }
  .tops_right {
    float: right;
    margin-right: 10px;
    ul {
      float: left;
      li {
        float: left;
        color: $TxteAllcolor;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
      }
    }
    .el-select {
      float: left;
      width: 140px;
      height: 30px;
      margin: 5px -10px 0 0;
    }
    .time_select {
      float: left;
      li {
        float: left;
        @include wh(60px, 24px);
        margin-top: 7px;
        line-height: 24px;
        &:hover {
          background-color: #e5f2ff;
          color: $TxteAllcolor;
        }
      }
      .li_select1 {
        color: #fff !important;
        background-color: #198cff !important;
      }
    }
    .chart_select {
      margin-left: 20px;
      li {
        float: left;
        @include wh(60px, 30px);
        margin-top: 5px;
        line-height: 30px;
        outline: 1px solid #e0e0e0;
        outline-offset: -1px;
        &:nth-child(1):hover {
          color: #fff;
          background-color: #3399ff;
        }
        &:nth-child(2):hover {
          background-color: #fff;
          color: #198cff;
          outline: 1px solid #198cff;
        }
      }
      .chart_select1 {
        color: #fff;
        background-color: #0080ff;
        outline: none;
      }
    }
  }
  .rank_tabs {
    overflow: auto;
    width: 89%;
    margin: 0 auto;
    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 40px;
      color: $TxteAllcolor;
      font-size: $fontSizeTwo;
      outline: 1px solid #b2d9ff;
      outline-offset: -1px;
      box-shadow: 0 2px 0 rgba(25, 140, 255, 0.1);
      @include flexible;
      @include alignItems(center);
      span:nth-child(2) {
        position: absolute;
      }
      span:last-child {
        // float: right;
        position: absolute;
        right: 0;
        margin-right: 40px;
        &.oneNum,
        &.twoNum,
        &.threeNum {
          position: absolute;
          top: 50%;
          right: 35px;
          @include wh(18px, 18px);
          margin-right: 0;
          @include translates(0, -50%);
        }
      }
      .oneNum {
        @include bgImg("../../assets/img/one.png");
      }
      .twoNum {
        @include bgImg("../../assets/img/two.png");
      }
      .threeNum {
        @include bgImg("../../assets/img/three.png");
      }
    }
  }
  .rank_tabs::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .rank_tabs::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 2px;
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
    background: #dddddd;
  }
  .rank_tabs::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: #f5f5f5;
  }
  .el-dialog__body .el-range-editor--small.el-input__inner {
    margin-left: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/analysis/index.vue